export default __webpack_public_path__ + "static/media/user-33638_960_720.9f0a877d.png";